var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.17051 17.3989L19.6205 9.91893C19.8009 9.84208 19.9547 9.7139 20.0628 9.55033C20.1709 9.38675 20.2286 9.195 20.2286 8.99893C20.2286 8.80285 20.1709 8.6111 20.0628 8.44753C19.9547 8.28395 19.8009 8.15577 19.6205 8.07893L2.17051 0.598927C2.01941 0.533021 1.85428 0.505769 1.69002 0.51963C1.52575 0.53349 1.36753 0.588026 1.22961 0.678319C1.09169 0.768611 0.978416 0.891819 0.900012 1.03683C0.821609 1.18183 0.780539 1.34408 0.780508 1.50893L0.770508 6.11893C0.770508 6.61893 1.14051 7.04893 1.64051 7.10893L15.7705 8.99893L1.64051 10.8789C1.14051 10.9489 0.770508 11.3789 0.770508 11.8789L0.780508 16.4889C0.780508 17.1989 1.51051 17.6889 2.17051 17.3989Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.1efda229faa8fdf9d6868d4627006ece.svg";
export { ForwardRef as ReactComponent };